import { parseGid } from "@shopify/hydrogen-react";
import { useQueryClient } from "react-query";
import { artistShopBuilderProductKeys } from "./queryKeys";
import { useUpdateProductDetails } from "./useUpdateProductDetails";

const useProductUpdateStatus = (productId: string, artistId: string) => {
  const mutation = useUpdateProductDetails(parseGid(productId).id);
  const queryClient = useQueryClient();

  const updateProductStatus = (status: "ACTIVE" | "DRAFT" | "ARCHIVED") => {
    mutation.mutate(
      {
        status,
        mediaIDsToDelete: [],
        mediaIDsToSequence: [],
        mediaURLsToAdd: [],
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(
            artistShopBuilderProductKeys.detail(artistId),
          );
        },
      },
    );
  };

  return { ...mutation, updateProductStatus };
};

export { useProductUpdateStatus };
